import { render } from "./coach-payment.vue?vue&type=template&id=27775686"
import script from "./coach-payment.vue?vue&type=script&lang=js"
export * from "./coach-payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__